import React from "react";

const PDFViewer = ({ url, width, height }) => {
  if (!url) {
    console.warn("[PDFViewer] No URL provided, showing placeholder");
    return (
      <div style={{ width, height, backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem", textAlign: "center" }}>
        <p className="text-muted mb-0">
          This document isn't available. It may have been deleted or you don't have access.
        </p>
      </div>
    );
  }

  return (
    <iframe
      title="PDF Document Viewer"
      aria-label="PDF Viewer"
      src={`${url}`}
      style={{ width, height, border: "none" }}
      allowFullScreen
      onLoad={() => undefined}
      onError={(e) => console.error("[PDFViewer] iframe error:", e)}
    >
      Your browser does not support PDFs. Please download the PDF to view it:{" "}
      <a href={url}>Download PDF</a>
    </iframe>
  );
};

PDFViewer.defaultProps = {
  width: "100%",
  height: "100vh",
};

export default PDFViewer;
